import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import FinanceiroGraficos from "../../pages/FinanceiroGraficos";
import FinanceiroTaxas from "../../pages/FinanceiroTaxas";

function TabsFinanceiro() {
  const [key, setKey] = useState();

  return (
    <div>
      <Tabs
        style={{ paddingTop: 7, marginTop: -1 }}
        id="controlled-tab-example"
        className="tabStyle"
        activeKey={key}
        onSelect={(key) => setKey(key)}
      >
        <Tab eventKey="FinanceiroGraficos" title="Gráficos" style={{ paddingLeft: 20 }}>
          <FinanceiroGraficos />
        </Tab>
        <Tab eventKey="FinanceiroTaxas" title="Taxas de Operação">
          <FinanceiroTaxas />
        </Tab>
      </Tabs>
    </div>
  );
}

export default TabsFinanceiro;
